import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DatePicker } from 'ui-components/components/date-picker';
import { MDash } from 'ui-components/components/mdash/mdash';

import Global from '../../../../../store/global-selectors';
import { areProductPropsEqual } from '../utils';
import styles from './styles.module.less';

/**
 * @param {import('../../../types').ColumnProps} props
 * @returns {React.ReactNode}
 */
const Column = ({ value }) => {
  const { product, updateProduct } = value;

  const onChange = useCallback(
    (date) => {
      updateProduct(product.rowKey ?? String(product.productId), 'expirationDate', date);
    },
    [product.rowKey, product.productId, updateProduct],
  );

  const dateFormat = useSelector(Global.selectUserUserDateFormat);

  if (product.isBundle) {
    return <MDash />;
  }

  return (
    <DatePicker
      allowPastDates
      calendarPosition='top-left'
      className={styles['date-picker']}
      dateFormat={dateFormat}
      onChange={onChange}
      value={product.expirationDate}
    />
  );
};

export const ExpDateColumn = memo(Column, areProductPropsEqual('expirationDate'));
